/**
 * @fileoverview added by tsickle
 * Generated from: models/property.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
import { KeyCollectionStateValue } from './key';
/**
 * The minimum desired length of a property address's "short description".
 * @type {?}
 */
var SHORT_DESCRIPTION_MIN_LENGTH = 10;
/** @enum {string} */
var PropertyAccess = {
    /** Access is provided by the customer who will be at home for each visit. */
    AtHome: "at home",
    /** Access is provided by a concierge, porter or receptionist. */
    Concierge: "concierg",
    /** The worker accesses the property using spare keys they hold. */
    Keys: "keys",
    /** The worker accesses the property using a hidden key. */
    KeyHidden: "keyhiddn",
    /** The worker collects the key from a KeyNest store. */
    KeyNest: "keynest",
    /** The worker collects the key from a locked key safe. */
    KeySafe: "keysafe",
    /** Access is provided by a supervisor on site. */
    Supervisor: "supervsr",
};
export { PropertyAccess };
/** @enum {string} */
var PropertyParkingLocation = {
    /** Parking is on the property (Eg: driveway). */
    Property: "property",
    /** Parking is in the street. */
    Street: "street",
    /** Customer will get worker a permit for parking. */
    Permit: "permit",
};
export { PropertyParkingLocation };
/**
 * A map of `PropertyAccess` to readable description of the access method, used for display purposes.
 * @type {?}
 */
export var ACCESS_DISPLAY = new Map([
    [PropertyAccess.AtHome, 'Customer at home'],
    [PropertyAccess.Concierge, 'Concierge'],
    [PropertyAccess.Keys, 'Spare keys'],
    [PropertyAccess.KeyHidden, 'Key hidden'],
    [PropertyAccess.KeyNest, 'KeyNest'],
    [PropertyAccess.KeySafe, 'Key safe'],
    [PropertyAccess.Supervisor, 'Supervisor on site']
]);
/**
 * A map of `PropertyAccess` to readable description of the access method, used for display and user-selection purposes.
 * @type {?}
 */
export var ACCESS_CHOICES = new Map([
    [PropertyAccess.AtHome, "I'll be at home"],
    [PropertyAccess.Concierge, 'Through a concierge'],
    [PropertyAccess.Keys, 'Using spare keys'],
    [PropertyAccess.KeyHidden, 'Using a hidden key'],
    [PropertyAccess.KeyNest, 'Using a KeyNest'],
    [PropertyAccess.KeySafe, 'Using a key safe'],
    [PropertyAccess.Supervisor, 'Through a supervisor']
]);
// List of all PropertyAccess types related to keys
/** @type {?} */
export var KEY_ACCESS_TYPES = [
    PropertyAccess.KeyHidden,
    PropertyAccess.KeyNest,
    PropertyAccess.KeySafe,
    PropertyAccess.Keys
];
// List of all PropertyAccess types related to concierges
/** @type {?} */
export var CONCIERGE_ACCESS_TYPES = [PropertyAccess.Concierge, PropertyAccess.Supervisor];
/** @enum {string} */
var PropertyType = {
    CommercialProperty: "commrcl",
    Flat: "flat",
    House: "house",
    Unknown: "",
};
export { PropertyType };
/**
 * A map of `PropertyType` to readable description of the property type, used for display and user-selection purposes.
 * Non-selectable property types are not included.
 * @type {?}
 */
export var PROPERTY_TYPE_CHOICES = new Map([
    [PropertyType.Flat, 'Flat'],
    [PropertyType.House, 'House']
]);
/**
 * A map of `PropertyType` to readable description of the property type, used for display purposes.
 * @type {?}
 */
var PROPERTY_TYPE_DISPLAY = new Map([
    [PropertyType.CommercialProperty, 'commercial property'],
    [PropertyType.Flat, 'flat'],
    [PropertyType.House, 'house'],
    [PropertyType.Unknown, 'property']
]);
/**
 * Represents the access information for a property.
 * @record
 */
export function PropertyAccessInformation() { }
if (false) {
    /** @type {?} */
    PropertyAccessInformation.prototype.access;
    /** @type {?|undefined} */
    PropertyAccessInformation.prototype.alarm;
    /** @type {?} */
    PropertyAccessInformation.prototype.alarmEntryInstructions;
    /** @type {?} */
    PropertyAccessInformation.prototype.alarmExitInstructions;
    /** @type {?} */
    PropertyAccessInformation.prototype.conciergeLocation;
    /** @type {?} */
    PropertyAccessInformation.prototype.findingEntranceInstructions;
    /** @type {?} */
    PropertyAccessInformation.prototype.hiddenKeyLocation;
    /** @type {?|undefined} */
    PropertyAccessInformation.prototype.key;
    /** @type {?|undefined} */
    PropertyAccessInformation.prototype.keyholder;
    /** @type {?|undefined} */
    PropertyAccessInformation.prototype.keyCollectionState;
    /** @type {?} */
    PropertyAccessInformation.prototype.keyNestCode;
    /** @type {?} */
    PropertyAccessInformation.prototype.keyNestLocation;
    /** @type {?} */
    PropertyAccessInformation.prototype.keySafeCode;
    /** @type {?} */
    PropertyAccessInformation.prototype.keySafeLocation;
    /** @type {?} */
    PropertyAccessInformation.prototype.keyTransfers;
    /** @type {?} */
    PropertyAccessInformation.prototype.lockingInstructions;
    /** @type {?} */
    PropertyAccessInformation.prototype.numKeys;
    /** @type {?} */
    PropertyAccessInformation.prototype.openingInstructions;
}
/**
 * Represents information about the cleaning equipment for a property.
 * @record
 */
export function PropertyCleaningEquipment() { }
if (false) {
    /** @type {?} */
    PropertyCleaningEquipment.prototype.binBagsLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.cleaningProductsLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.hooverLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.ironLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.ironingBoardLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.mopLocation;
    /** @type {?} */
    PropertyCleaningEquipment.prototype.rubbishLocation;
}
/**
 * Represents information about parking for a property.
 * @record
 */
export function PropertyParkingInformation() { }
if (false) {
    /** @type {?} */
    PropertyParkingInformation.prototype.freeParking;
    /** @type {?} */
    PropertyParkingInformation.prototype.parkingLocation;
    /** @type {?} */
    PropertyParkingInformation.prototype.parkingInstructions;
}
/**
 * Represents information about the pets at a property.
 * @record
 */
export function PropertyPets() { }
if (false) {
    /** @type {?} */
    PropertyPets.prototype.cats;
    /** @type {?} */
    PropertyPets.prototype.dogs;
    /** @type {?} */
    PropertyPets.prototype.havePets;
    /** @type {?} */
    PropertyPets.prototype.otherPets;
    /** @type {?} */
    PropertyPets.prototype.otherPetsType;
    /** @type {?} */
    PropertyPets.prototype.petNames;
    /** @type {?} */
    PropertyPets.prototype.petInstructions;
}
/**
 * Model containing just the address fields of a property
 * @record
 */
export function Address() { }
if (false) {
    /** @type {?} */
    Address.prototype.city;
    /** @type {?} */
    Address.prototype.line1;
    /** @type {?} */
    Address.prototype.line2;
    /** @type {?} */
    Address.prototype.line3;
    /** @type {?} */
    Address.prototype.postcode;
    /** @type {?} */
    Address.prototype.addressLines;
    /** @type {?} */
    Address.prototype.fullAddress;
    /** @type {?} */
    Address.prototype.fullAddressMultiLine;
}
/** @type {?} */
export var address = model.extend((/** @type {?} */ ((/** @type {?} */ ({
    modelName: 'address'
})))));
defineModelProperties(address, {
    addressLines: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.getOrCache('addressLines', (/**
             * @return {?}
             */
            function () { return commaDelimited(_this, ['line1', 'line2', 'line3', 'city']); }));
        }
    },
    fullAddress: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.getOrCache('fullAddress', (/**
             * @return {?}
             */
            function () {
                return commaDelimited(_this, ['line1', 'line2', 'line3', 'city', 'postcode']);
            }));
        }
    },
    fullAddressMultiLine: {
        get: /**
         * @return {?}
         */
        function () {
            return this.fullAddress.replace(/, /g, '\n');
        }
    }
});
/**
 * Base model for a customer's property, containing all relevant fields returned by the API.
 * @record
 */
function BasePropertyModel() { }
if (false) {
    /** @type {?} */
    BasePropertyModel.prototype.access;
    /** @type {?} */
    BasePropertyModel.prototype.accountId;
    /** @type {?|undefined} */
    BasePropertyModel.prototype.bathrooms;
    /** @type {?|undefined} */
    BasePropertyModel.prototype.bedrooms;
    /** @type {?} */
    BasePropertyModel.prototype.flexibleWithKeys;
    /** @type {?} */
    BasePropertyModel.prototype.perks;
    /** @type {?|undefined} */
    BasePropertyModel.prototype.postcodeText;
    /** @type {?} */
    BasePropertyModel.prototype.propertyType;
    /** @type {?|undefined} */
    BasePropertyModel.prototype.recommendedHours;
}
/**
 * @record
 */
function PropertyExpandables() { }
if (false) {
    /** @type {?|undefined} */
    PropertyExpandables.prototype.accessInformation;
    /** @type {?|undefined} */
    PropertyExpandables.prototype.cleaningEquipment;
    /** @type {?|undefined} */
    PropertyExpandables.prototype.key;
    /** @type {?|undefined} */
    PropertyExpandables.prototype.parkingInformation;
    /** @type {?|undefined} */
    PropertyExpandables.prototype.pets;
    /** @type {?|undefined} */
    PropertyExpandables.prototype.tradespeopleEnabled;
}
/**
 * Helper properties for the `Property` model.
 * @record
 */
function PropertyModelMixin() { }
if (false) {
    /**
     * A readable description of the chosen access method, for display purposes.
     * @type {?}
     */
    PropertyModelMixin.prototype.accessChoice;
    /**
     * A readable description of the access method, for display purposes.
     * @type {?}
     */
    PropertyModelMixin.prototype.accessDisplay;
    /**
     * A string containing all lines of the address except the postcode, comma-separated.
     * @type {?}
     */
    PropertyModelMixin.prototype.addressLines;
    /**
     * A string containing all lines of the address, comma-separated.
     * @type {?}
     */
    PropertyModelMixin.prototype.fullAddress;
    /**
     * A string containing all lines of the address, with newlines.
     * @type {?}
     */
    PropertyModelMixin.prototype.fullAddressMultiLine;
    /**
     * `true` if the property has listed the location of at least one cleaning equipment
     * @type {?}
     */
    PropertyModelMixin.prototype.hasCleaningEquipment;
    /**
     * `true` if the property has a key collection in the "pending" or "done" state.
     * @type {?}
     */
    PropertyModelMixin.prototype.hasKeyCollection;
    /**
     * `true` if the property has a key collection in the "done" state.
     * @type {?}
     */
    PropertyModelMixin.prototype.hasFinishedKeyCollection;
    /**
     * `true` if the property has a key collection in the "pending" state.
     * @type {?}
     */
    PropertyModelMixin.prototype.hasPendingKeyCollection;
    /**
     * The human readable property type.
     * @type {?|undefined}
     */
    PropertyModelMixin.prototype.propertyTypeDisplay;
    /**
     * A string containing all lines of the address starting from the second line, comma-separated.
     * @type {?}
     */
    PropertyModelMixin.prototype.restOfAddress;
    /**
     * A short description of the address, which will be just the first line if it is long enough.
     * If the first line is too short, the second line is added. If it is still too short, the third line is added.
     * \@example
     * ```
     * // Example with a long first line:
     * property.line1 = '1 Example Road'
     * property.line2 = 'Something else'
     * property.shortDescription
     * // "1 Example Road"
     *
     * // Example with a short first line:
     * property.line1 = 'Flat 1'
     * property.line2 = 'Example Road'
     * property.shortDescription
     * // "Flat 1, Example Road"
     * ```
     * @type {?}
     */
    PropertyModelMixin.prototype.shortDescription;
}
/**
 * Model representing a customer's property.
 * @record
 */
export function Property() { }
/** @type {?} */
export var property = model.extend((/** @type {?} */ ({
    modelName: 'property'
})));
/**
 * Return the matching keys for the given property as a single
 * comma-delimited string. Ignore all empty properties.
 * @param {?} prop
 * @param {?} keys
 * @return {?}
 */
function commaDelimited(prop, keys) {
    return keys
        .filter((/**
     * @param {?} key
     * @return {?}
     */
    function (key) { return prop[key]; }))
        .map((/**
     * @param {?} key
     * @return {?}
     */
    function (key) { return (key === 'postcode' ? prop[key].full : prop[key]); }))
        .filter((/**
     * @param {?} part
     * @return {?}
     */
    function (part) { return part && part.trim() !== ''; }))
        .join(', ');
}
// Implements helper properties
defineModelProperties(property, {
    accessChoice: {
        get: /**
         * @return {?}
         */
        function () {
            return ACCESS_CHOICES.get(this.access) || '';
        }
    },
    accessDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            return ACCESS_DISPLAY.get(this.access) || 'Unknown';
        }
    },
    addressLines: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.getOrCache('addressLines', (/**
             * @return {?}
             */
            function () { return commaDelimited(_this, ['line1', 'line2', 'line3', 'city']); }));
        }
    },
    fullAddress: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.getOrCache('fullAddress', (/**
             * @return {?}
             */
            function () {
                return commaDelimited(_this, ['line1', 'line2', 'line3', 'city', 'postcode']);
            }));
        }
    },
    fullAddressMultiLine: {
        get: /**
         * @return {?}
         */
        function () {
            return this.fullAddress.replace(/, /g, '\n');
        }
    },
    restOfAddress: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.getOrCache('restOfAddress', (/**
             * @return {?}
             */
            function () { return commaDelimited(_this, ['line2', 'line3', 'city', 'postcode']); }));
        }
    },
    shortDescription: {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            // Filter out empty address lines
            /** @type {?} */
            var keys = ['line1', 'line2', 'line3'];
            /** @type {?} */
            var nonEmptyKeys = keys.filter((/**
             * @param {?} key
             * @return {?}
             */
            function (key) { return _this[key] && _this[key].trim() !== ''; }));
            // Return the shortest comma-delimited string that is more than 10 characters
            /** @type {?} */
            var result = '';
            for (var i = 0; i < nonEmptyKeys.length; i++) {
                result = commaDelimited(this, nonEmptyKeys.slice(0, i + 1));
                if (result.length > SHORT_DESCRIPTION_MIN_LENGTH) {
                    return result;
                }
            }
            return result;
        }
    },
    hasKeyCollection: {
        get: /**
         * @return {?}
         */
        function () {
            return (!!(this.accessInformation && this.accessInformation.keyCollectionState) &&
                this.accessInformation.keyCollectionState.state !== KeyCollectionStateValue.None);
        }
    },
    hasFinishedKeyCollection: {
        get: /**
         * @return {?}
         */
        function () {
            return (!!(this.accessInformation && this.accessInformation.keyCollectionState) &&
                this.accessInformation.keyCollectionState.state === KeyCollectionStateValue.Done);
        }
    },
    hasPendingKeyCollection: {
        get: /**
         * @return {?}
         */
        function () {
            return (!!(this.accessInformation && this.accessInformation.keyCollectionState) &&
                this.accessInformation.keyCollectionState.state === KeyCollectionStateValue.Pending);
        }
    },
    hasCleaningEquipment: {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.cleaningEquipment) {
                return false;
            }
            return !!(this.cleaningEquipment.binBagsLocation ||
                this.cleaningEquipment.cleaningProductsLocation ||
                this.cleaningEquipment.hooverLocation ||
                this.cleaningEquipment.ironLocation ||
                this.cleaningEquipment.ironingBoardLocation ||
                this.cleaningEquipment.rubbishLocation);
        }
    },
    propertyTypeDisplay: {
        get: /**
         * @return {?}
         */
        function () {
            return PROPERTY_TYPE_DISPLAY.get(this.propertyType) || PROPERTY_TYPE_DISPLAY.get(PropertyType.Unknown);
        }
    }
});
